//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    objectId: {
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showDialog: false,
      loading: false,
      from: { keyword: '', limit: 100, offset: 0, sort: '' },
      list: [], // 对象列表
      fieldList: [], // 字段列表
      pageSize: 10,
      pageIndex: 1,
      total: 0,
      selectRow: {},
    };
  },
  created() {
    // 获取列表
    if (!this.objectId) {
      this.geObjectList();
    } else {
      this.getFieldList();
    }
  },
  methods: {
    async geObjectList() {
      this.loading = true;
      this.$request({
        url: this.$api.metaGetObjectList,
        data: {
          ...this.from,
          limit: this.pageSize,
          offset: (this.pageIndex - 1) * this.pageSize,
        },
        cb: ({ objects, count }) => {
          this.total = Number(count);
          this.list = objects;
          this.loading = false;
        },
        fault: () => {
          this.$message.error('列表请求失败');
          this.loading = false;
        },
      });
    },
    async getFieldList() {
      this.loading = true;
      try {
        const { fields } = await this.$request({
          url: this.$api.metaGetObjectFields,
          data: {
            object_id: this.objectId,
          },
        });
        this.fieldList = fields;
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    select(row) {
      this.selectRow = row;
      this.$emit('select', row);
      this.showDialog = false;
    },
    // 分页器
    handleSizeChange(value) {
      this.pageIndex = 1;
      this.pageSize = value;
      this.geObjectList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.geObjectList();
    },
  },
};
